import axios from 'axios'
import getLanguage from "./getLanguage"
import getCoupon from "./getCoupon"

// **************************************************
// ******************** USER API ********************
// **************************************************

export const getSubscriptionStatus = async (token) => {
    const queryParams = Buffer.from(JSON.stringify({token: token, p: 1})).toString('base64')
    const url = `${process.env['REACT_APP_USER_API']}/subscription/status?p=${queryParams}`

    try {
        const result = await axios.get(url)
        return result.data
    } catch (err) {
        console.error(url, err)
        return {success: false}
    }
}

export const getUserData = async (token) => {
    const queryParams = Buffer.from(JSON.stringify({token: token, p: 1})).toString('base64')
    const url = `${process.env['REACT_APP_USER_API']}?p=${queryParams}`

    try {
        const result = await axios.get(url)
        return result.data
    } catch (err) {
        console.error(url, err)
        return {success: false}
    }
}

export const updateIntegrations = async (token) => {
    const params = new URLSearchParams()
    params.append('token', token)

    const url = `${process.env['REACT_APP_USER_API']}/integrations?p=1`

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }

    return await axios.put(url, params, config)
}

export const deleteAccount = async (token) => {
    const url = `${process.env['REACT_APP_USER_API']}/?lang=${getLanguage()}&token=${token}&p=1`
    return await axios.delete(url)
}

// ****************************************************
// ******************** STRIPE API ********************
// ****************************************************

export const createStripePurchaseSession = async (userID) => {
    const purchaseSessionPostPayload = {
        userID: userID,
        lang: getLanguage(),
        coupon: getCoupon()
    }

    return await axios.post(`${process.env['REACT_APP_STRIPE_API_ENDPOINT']}/subscription/purchaseSession`, purchaseSessionPostPayload)
}

export const createStripeManageSession = async (stripeCustomerID) => {
    const purchaseSessionPostPayload = {
        customerID: stripeCustomerID,
        lang: getLanguage()
    }

    return await axios.post(`${process.env['REACT_APP_STRIPE_API_ENDPOINT']}/subscription/manage`, purchaseSessionPostPayload)
}

// ********************************************************
// ******************** SCHOOLZONE API ********************
// ********************************************************

// TODO schoolzone calls should be moved here

